import { Box } from "@mantine/core";

interface PostImageProps {
  src: string;
  alt: string;
  caption?: string;
  aspectRatio?: string;
  aspectratio?: string;
  width?: number;
  height?: number;
}

export function PostImage({
  src,
  alt,
  caption,
  aspectRatio,
  aspectratio,
  width,
  height,
}: PostImageProps) {
  const ratio = aspectRatio ?? aspectratio;
  const wrapperStyle: React.CSSProperties = {
    borderRadius: 12,
    overflow: "hidden",
    background: "var(--surface-placeholder)",
  };

  if (ratio) {
    wrapperStyle.aspectRatio = ratio;
  }

  return (
    <Box component="figure" my="xl" style={{ margin: 0 }}>
      <Box style={wrapperStyle}>
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          loading="lazy"
          decoding="async"
          style={{
            width: "100%",
            height: ratio ? "100%" : "auto",
            objectFit: ratio ? "cover" : "contain",
            display: "block",
          }}
        />
      </Box>
      {caption && (
        <Box
          component="figcaption"
          mt="xs"
          style={{
            fontSize: 13,
            color: "var(--ink-muted)",
            textAlign: "center",
            fontStyle: "italic",
          }}
        >
          {caption}
        </Box>
      )}
    </Box>
  );
}

export default PostImage;
